import { useQuery } from "@tanstack/react-query";

import { SELECTED_LENDER_RESPONSE_FIELD_REQUESTS_STORE_KEY } from "@krea/customer-features/store/queryClient";
import { useGetUserData } from "@krea/customer-features/store/user/hooks/queries/useGetUserData";

import { getSelectedLenderResponse } from "@/services/graphql/lender-response/getSelectedLenderResponse";

export const useGetSelectedLenderResponse = () => {
  const { data } = useGetUserData();
  const loanApplicationID = data?.currentLoanApplication?.id;

  return useQuery({
    queryKey: [
      SELECTED_LENDER_RESPONSE_FIELD_REQUESTS_STORE_KEY,
      loanApplicationID,
    ],
    queryFn: async () => {
      try {
        const response = await getSelectedLenderResponse();
        const lenderResponse =
          response.me.currentLoanApplication.selectedLenderResponse;

        return lenderResponse;
      } catch (err) {
        console.error("Failed to fetch lender response data: err", err);
      }
    },
    enabled: !!loanApplicationID,
  });
};
